module.exports = __webpack_public_path__ + "media/images/logo-de4bf1b4d09a9266e1ae23cc19f02c0e.svg";